module.exports = __webpack_public_path__ + "static/media/murdoch.1fce3d9c.png";